function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import getViewportHeight from "../getViewportHeight";
import getViewportWidth from "../getViewportWidth";
const TOP = /top/;
const BOTTOM = /bottom/;
const LEFT = /left/;
const RIGHT = /right/;
/**
 * Determine whether a rendered layer should be vertically and/or horizontally shifted
 * around the context to remain in view, based on viewport edges.
 */
function calculateAutoflip(config) {
  const {
    autoflipBehavior
  } = config;
  const verticalResult = autoflipBehavior === 'both' || autoflipBehavior === 'vertical' ? // eslint-disable-next-line @typescript-eslint/no-use-before-define
  _objectSpread(_objectSpread({}, config), calculateVerticalAutoflip(config)) : config;
  return autoflipBehavior === 'both' || autoflipBehavior === 'horizontal' ?
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  calculateHorizontalAutoflip(verticalResult) : verticalResult;
}
function adjustmentFactor(contextMeetingPoint) {
  if (TOP.test(contextMeetingPoint) || LEFT.test(contextMeetingPoint)) {
    return 0;
  }
  if (BOTTOM.test(contextMeetingPoint) || RIGHT.test(contextMeetingPoint)) {
    return 1;
  }
  return 0.5;
}
function shiftForVerticalCardinal(config) {
  const {
    contextClientRect,
    contextMeetingPoint,
    layerRect,
    layerMeetingPoint,
    offsetX
  } = config;
  const {
    left: contextLeft,
    width: contextWidth
  } = contextClientRect;
  const {
    width: layerWidth
  } = layerRect;
  const layerLeft = offsetX + contextLeft + adjustmentFactor(contextMeetingPoint) * contextWidth - 0.5 * layerWidth;
  const layerRight = layerLeft + layerWidth;
  const viewportWidth = getViewportWidth();
  const shiftForTop = () => {
    if (layerRight > viewportWidth) {
      return 'topright';
    }
    if (layerLeft < 0) {
      return 'topleft';
    }
    return layerMeetingPoint;
  };
  const shiftForBottom = () => {
    if (layerRight > viewportWidth) {
      return 'bottomright';
    }
    if (layerLeft < 0) {
      return 'bottomleft';
    }
    return layerMeetingPoint;
  };
  return {
    contextMeetingPoint,
    layerMeetingPoint: layerMeetingPoint === 'top' ? shiftForTop() : shiftForBottom()
  };
}
function shiftForHorizontalCardinal(config) {
  const {
    contextClientRect,
    contextMeetingPoint,
    layerRect,
    layerMeetingPoint,
    offsetY
  } = config;
  const {
    top: contextTop,
    height: contextHeight
  } = contextClientRect;
  const {
    height: layerHeight
  } = layerRect;
  const layerTop = offsetY + contextTop + adjustmentFactor(contextMeetingPoint) * contextHeight - 0.5 * layerHeight;
  const layerBottom = layerTop + layerHeight;
  const viewportHeight = getViewportHeight();
  const shiftForLeft = () => {
    if (layerBottom > viewportHeight) {
      return 'bottomleft';
    }
    if (layerTop < 0) {
      return 'topleft';
    }
    return layerMeetingPoint;
  };
  const shiftForRight = () => {
    if (layerBottom > viewportHeight) {
      return 'bottomright';
    }
    if (layerTop < 0) {
      return 'topright';
    }
    return layerMeetingPoint;
  };
  return {
    contextMeetingPoint,
    layerMeetingPoint: layerMeetingPoint === 'left' ? shiftForLeft() : shiftForRight()
  };
}
function flipVertically(meetingPoint) {
  switch (meetingPoint) {
    case 'top':
      return 'bottom';
    case 'topleft':
      return 'bottomleft';
    case 'topright':
      return 'bottomright';
    case 'bottom':
      return 'top';
    case 'bottomleft':
      return 'topleft';
    case 'bottomright':
      return 'topright';
    default:
      return meetingPoint;
  }
}
function flipHorizontally(meetingPoint) {
  switch (meetingPoint) {
    case 'left':
      return 'right';
    case 'topleft':
      return 'topright';
    case 'topright':
      return 'topleft';
    case 'right':
      return 'left';
    case 'bottomleft':
      return 'bottomright';
    case 'bottomright':
      return 'bottomleft';
    default:
      return meetingPoint;
  }
}
function calculateHorizontalAutoflip(config) {
  const {
    contextClientRect,
    contextMeetingPoint,
    flipAxis,
    layerRect,
    layerMeetingPoint,
    offsetX
  } = config;
  if (layerMeetingPoint === 'top' || layerMeetingPoint === 'bottom') {
    return shiftForVerticalCardinal(config);
  }
  const {
    width: layerWidth
  } = layerRect;
  const contextRectPoint = LEFT.test(contextMeetingPoint) ? contextClientRect.left : contextClientRect.right;
  if (LEFT.test(layerMeetingPoint)) {
    const viewportWidth = getViewportWidth();
    const layerRight = contextRectPoint + layerWidth + offsetX;
    if (layerRight > viewportWidth) {
      return {
        contextMeetingPoint: flipAxis === 'context-center' ? flipHorizontally(contextMeetingPoint) : contextMeetingPoint,
        layerMeetingPoint: flipHorizontally(layerMeetingPoint)
      };
    }
  }
  if (RIGHT.test(layerMeetingPoint)) {
    const layerLeft = contextRectPoint - layerWidth + offsetX;
    if (layerLeft < 0) {
      return {
        contextMeetingPoint: flipAxis === 'context-center' ? flipHorizontally(contextMeetingPoint) : contextMeetingPoint,
        layerMeetingPoint: flipHorizontally(layerMeetingPoint)
      };
    }
  }
  return {
    contextMeetingPoint,
    layerMeetingPoint
  };
}
function calculateVerticalAutoflip(config) {
  const {
    contextClientRect,
    contextMeetingPoint,
    flipAxis,
    layerRect,
    layerMeetingPoint,
    offsetY
  } = config;
  if (layerMeetingPoint === 'left' || layerMeetingPoint === 'right') {
    return shiftForHorizontalCardinal(config);
  }
  const {
    height: layerHeight
  } = layerRect;

  // If the layer is positioned above the context, flip it if its top is
  // above the top of the viewport.
  if (BOTTOM.test(layerMeetingPoint)) {
    const layerTop = contextClientRect.top - layerHeight + offsetY;
    if (layerTop > 0) {
      return {
        contextMeetingPoint,
        layerMeetingPoint
      };
    }
    return {
      contextMeetingPoint: flipAxis === 'context-center' ? flipVertically(contextMeetingPoint) : contextMeetingPoint,
      layerMeetingPoint: flipVertically(layerMeetingPoint)
    };
  }

  // If the layer is positioned below the context, flip it if its bottom is
  // below the bottom of the viewport.
  if (TOP.test(layerMeetingPoint)) {
    const viewportHeight = getViewportHeight();
    const layerBottom = contextClientRect.top + contextClientRect.height + layerHeight + offsetY;
    if (layerBottom < viewportHeight) {
      return {
        contextMeetingPoint,
        layerMeetingPoint
      };
    }
    return {
      contextMeetingPoint: flipAxis === 'context-center' ? flipVertically(contextMeetingPoint) : contextMeetingPoint,
      layerMeetingPoint: flipVertically(layerMeetingPoint)
    };
  }
  return {
    contextMeetingPoint,
    layerMeetingPoint
  };
}
export default calculateAutoflip;